import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _get from 'lodash/get';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './MyAccount.module.css';
import PasswordCriteriaHelper from 'components/Auth/PasswordCriteriaHelper/PasswordCriteriaHelper';
import ProfileCard from 'components/MyAccount/ProfileCard/ProfileCard';
import Button from 'components/UI/Button/Button';
import FormDialogue from 'components/UI/FormDialogue/FormDialogue';
import Input from 'components/UI/Input/Input';
import Modal from 'components/UI/Modal/Modal';
import Spinner from 'components/UI/Spinner/Spinner';
import Verify from 'containers/Auth/Verify/Verify';
import ProfileForm from 'containers/ProfileForm/ProfileForm';
import { checkValidity, getRgbFromColorName, numberToPhoneNumber, updateObject } from 'shared/utility';
import * as actions from 'store/actions';
import { submitProfile } from 'store/thunks';

class MyAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEmailEditDialogue: false,
      showPasswordEditDialogue: false,
      showMobileEditDialogue: false,
      showProfileForm: false,
      showVerifyMobileDialogue: false,
      email: {
        elementType: 'input',
        elementConfig: {
          type: 'email',
          placeholder: 'Email Address',
        },
        value: this.props.signedInAs.Email !== null ? this.props.signedInAs.Email : '',
        validation: {
          required: true,
          isEmail: true,
          validationError: 'Please enter a valid email address',
        },
        valid: true,
        touched: false,
      },
      oldPassword: {
        elementType: 'input',
        elementConfig: {
          type: 'password',
          placeholder: 'Current Password',
          minLength: 1,
        },
        value: '',
        validation: {
          required: true,
          validationError: 'Please enter your current password',
        },
        valid: false,
        touched: false,
      },
      password: {
        elementType: 'input',
        elementConfig: {
          type: 'password',
          placeholder: 'Password',
          maxLength: 40,
        },
        value: '',
        validation: {
          required: true,
          minLength: 7,
          validationError: '',
        },
        valid: false,
        touched: false,
      },
      passwordConfirmation: {
        elementType: 'input',
        elementConfig: {
          type: 'password',
          placeholder: 'Password Confirmation',
          maxLength: 40,
        },
        value: '',
        validation: {
          required: true,
          matchesPassword: true,
          validationError: '',
        },
        valid: false,
        touched: false,
      },
      mobileNumber: {
        elementType: 'input',
        elementConfig: {
          type: 'tel',
          placeholder: 'Phone Number',
        },
        value: this.props.signedInAs.Phone ? numberToPhoneNumber(this.props.signedInAs.Phone) : '',
        validation: {
          required: true,
          isPhone: true,
          validationError: 'Please enter a valid phone number',
        },
        valid: true,
        touched: false,
      },
      error: this.props.error,
      emailUpdated: false,
      passwordUpdated: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.emailUpdated === true && this.props.emailUpdated !== prevProps.emailUpdated) {
      this.setState({ emailUpdated: true, showEmailEditDialogue: false });
    }
    if (this.props.passwordUpdated === true && this.props.passwordUpdated !== prevProps.passwordUpdated) {
      this.setState({ passwordUpdated: true, showPasswordEditDialogue: false });
    }
    // If mobile number is added or updated, hide other dialogues and show verify mobile number dialogue
    if (this.props.signedInAs.Phone !== prevProps.signedInAs.Phone) this.setState({ showMobileEditDialogue: false });
    // If phone number needs verification, show mobile number verification dialogue
    if (this.props.signedInAs.PhoneStatus === 'NotVerified' && !this.state.showVerifyMobileDialogue) {
      this.setState({ showVerifyMobileDialogue: true });
    }
    if (this.props.signedInAs.PhoneStatus === 'Verified' && this.state.showVerifyMobileDialogue) {
      this.setState({ showVerifyMobileDialogue: false });
    }
    // If profile form is open and user info is successfully submitted, close profile form.
    if (this.state.showProfileForm && this.props.submitted && !prevProps.submitted) this.setState({ showProfileForm: false });
    if (prevProps.email === null && this.props.email !== null) {
      const updatedControl = updateObject(this.state.email, {
        value: this.props.signedInAs.Email,
        valid: checkValidity(this.props.signedInAs.Email, this.state.email.validation, this.state.password.value),
        touched: false,
      });
      this.setState({ email: updatedControl });
    }
  }

  inputChangedHandler = (event, controlName) => {
    let value = event.target.value;
    if (controlName === 'mobileNumber') value = numberToPhoneNumber(value);
    const isValid =
      controlName === 'oldPassword' ? value.length > 0 : checkValidity(value, this.state[controlName].validation, this.state.password.value);
    let updatedControl = updateObject(this.state[controlName], {
      value,
      valid: isValid,
      touched: true,
    });
    // If the user has updated the password to now match the passwordConfirmation and the password is now valid,
    // update passwordConfirmation validity as well.
    if (
      controlName === 'password' &&
      value === this.state.passwordConfirmation.value &&
      this.state.password.value !== this.state.passwordConfirmation.value &&
      isValid
    ) {
      updatedControl = updateObject(this.state.passwordConfirmation, {
        valid: true,
      });
    }
    this.setState({ [controlName]: updatedControl });
  };

  submitMobileHandler = () => {
    const mobileNumber = this.state.mobileNumber.value.replace(/[^\d]/g, '');
    this.props.onSubmitProfile(this.props.signedInAs.UserId, null, null, null, null, null, null, mobileNumber, false, false);
  };

  handlePasswordUpdate = () => {
    this.setState({ passwordUpdated: false });
    this.props.onPasswordUpdate(this.state.oldPassword.value, this.state.password.value);
  };

  togglePasswordDialogue = () => {
    this.setState({ showPasswordEditDialogue: !this.state.showPasswordEditDialogue });
  };

  handleEmailUpdate = () => {
    this.setState({ emailUpdated: false });
    this.props.onEmailUpdate(this.state.email.value);
  };

  toggleEmailDialogue = () => {
    this.setState({ showEmailEditDialogue: !this.state.showEmailEditDialogue });
  };

  toggleMobileDialogue = () => {
    this.setState({ showMobileEditDialogue: !this.state.showMobileEditDialogue });
  };

  closeAccountPage = () => {
    const nextPath = this.props.location.state && this.props.location.state.prevPath ? this.props.location.state.prevPath : '/';
    this.props.history.push(nextPath);
  };

  handleInitProfileForm = (userId) => {
    const user =
      userId === this.props.signedInAs.UserId
        ? this.props.signedInAs
        : this.props.managedUsers.find((u) => u.UserId === userId)
        ? this.props.managedUsers.find((u) => u.UserId === userId)
        : {};
    const isManagedUser = userId !== this.props.signedInAs.UserId;
    const profileStatus =
      userId === this.props.signedInAs.UserId || this.props.managedUsers.find((u) => u.UserId === userId) ? 'Completed' : 'NotComplete';
    this.props.onInitProfileForm(
      user.UserId,
      _get(user, 'ImageURL', _get(user, 'ThumbURL')),
      user.FirstName,
      user.LastName,
      user.NickName,
      user.DateBirthDay,
      user.Color,
      profileStatus,
      isManagedUser,
      false,
    );
    this.setState({ showProfileForm: true });
  };

  render = () => {
    let accountWindow = <Spinner lightColor />;
    let addMobileNumber = null;
    const phoneNumberInvalid = this.state.mobileNumber.value.replace(/[^\d]/g, '').length !== 10;

    const managedUserProfiles = this.props.signedInAs.ManagedUsers
      ? this.props.signedInAs.ManagedUsers.map((managedUser) => {
          return <ProfileCard key={managedUser.UserId} user={managedUser} isEditable handleProfileEdit={this.handleInitProfileForm} />;
        })
      : [];

    if (this.props.signedInAs.UserId && !this.props.signedInAs.Phone) {
      addMobileNumber = (
        <div className={classes.AddMobileContainer}>
          <div className={classes.Header}>
            <FontAwesomeIcon icon="mobile-alt" className={classes.MobileIcon} />
            <h2>Enter Mobile Phone Number</h2>
            <p>A verified phone number makes Riza more secure and easier for members to contact each other.</p>
          </div>
          <div className={classes.Actions}>
            <Input
              elementType="tel"
              value={this.state.mobileNumber.value}
              inputClassName="AccountInput"
              placeholder="Phone number"
              invalid={phoneNumberInvalid}
              shouldValidate={false}
              validationError="please enter a valid phone number"
              touched={this.state.touched}
              changed={(event) => this.inputChangedHandler(event, 'mobileNumber')}
              // blurred={false ? (event) => this.props.focusedOut(event) : undefined}
            />
            <Button btnType="AddPhone" clicked={this.submitMobileHandler} disabled={phoneNumberInvalid}>
              Verify
            </Button>
          </div>
        </div>
      );
    }

    if (this.state.showProfileForm) {
      accountWindow = (
        <div className={classes.ProfileFormContainer}>
          <ProfileForm close={() => this.setState({ showProfileForm: false })} />
        </div>
      );
    } else if (this.props.signedInAs.UserId) {
      accountWindow = (
        <div className={classes.FormWrapper}>
          <div className={classes.LeftColumn}>
            <div className={classes.AccountOwnerCard}>
              <div className={classes.ThumbWrapper}>
                {this.props.signedInAs.ImageURL ? (
                  <img
                    style={{
                      border: this.props.signedInAs.Color
                        ? `6px solid ${getRgbFromColorName(this.props.signedInAs.Color)}`
                        : '6px solid rgb(108, 162, 183)',
                      backgroundColor: this.props.signedInAs.Color ? getRgbFromColorName(this.props.signedInAs.Color) : 'rgb(108, 162, 183)',
                    }}
                    className={classes.ThumbImage}
                    src={this.props.signedInAs.ImageURL}
                    alt="user avatar"
                  />
                ) : (
                  <FontAwesomeIcon
                    style={{ color: this.props.signedInAs.Color ? getRgbFromColorName(this.props.signedInAs.Color) : 'hsl(0, 0%, 90%)' }}
                    icon="user-circle"
                    className={classes.UserIcon}
                  />
                )}
                <span
                  className={classes.UserFirstName}
                  style={{ backgroundColor: this.props.signedInAs.Color ? getRgbFromColorName(this.props.signedInAs.Color) : 'hsl(0, 0%, 90%)' }}
                >
                  {this.props.signedInAs.FirstName}
                </span>
              </div>
              <div className={classes.FullNameEdit}>
                <h4>{this.props.signedInAs.FullName}</h4>
                <p className={classes.Edit} onClick={() => this.handleInitProfileForm(this.props.signedInAs.UserId)}>
                  Edit
                </p>
              </div>
            </div>
            {managedUserProfiles.length > 0 ? (
              <div className={classes.ManagedUsersContainer}>
                <h2>Managed Profiles</h2>
                {managedUserProfiles}
              </div>
            ) : null}

            <Button clicked={this.handleInitProfileForm} btnType="Account">
              Create a managed profile
            </Button>
          </div>
          <div className={classes.RightColumn}>
            <div className={classes.UserAuthData}>
              <div className={classes.UserAuthDataProperty}>
                <div>
                  <span className={classes.Label}>Email</span>
                  <span className={classes.Value}>{this.props.signedInAs.Email}</span>
                </div>
                <span className={classes.Edit} onClick={this.toggleEmailDialogue}>
                  Edit
                </span>
              </div>
              {this.props.signedInAs.Phone ? (
                <div className={classes.UserAuthDataProperty}>
                  <div>
                    <span className={classes.Label}>Mobile Number</span>
                    <span className={classes.Value}>{numberToPhoneNumber(this.props.signedInAs.Phone)}</span>
                  </div>
                  <span className={classes.Edit} onClick={this.toggleMobileDialogue}>
                    Edit
                  </span>
                </div>
              ) : null}
              <div className={classes.UserAuthDataProperty}>
                <div>
                  <span className={classes.Label}>Password</span>
                  <span className={classes.Value}>&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;</span>
                </div>
                <span className={classes.Edit} onClick={this.togglePasswordDialogue}>
                  Edit
                </span>
              </div>
            </div>
            {addMobileNumber}
          </div>
        </div>
      );
    }

    let emailUpdateFields = (
      <Input
        className="MyAccount"
        value={this.state.email.value}
        elementType={this.state.email.elementType}
        elementConfig={this.state.email.elementConfig}
        invalid={!this.state.email.valid}
        touched={this.state.email.touched}
        shouldValidate={this.state.email.validation !== null}
        placeholder={this.state.email.elementConfig.placeholder}
        validationError={this.state.email.validation ? this.state.email.validation.validationError : null}
        changed={(event) => this.inputChangedHandler(event, 'email')}
      />
    );
    if (this.props.loading === true) {
      emailUpdateFields = <Spinner />;
    }

    const mobileNumberUpdateField = (
      <Input
        className="MyAccount"
        value={this.state.mobileNumber.value}
        elementType={this.state.mobileNumber.elementType}
        elementConfig={this.state.mobileNumber.elementConfig}
        invalid={!this.state.mobileNumber.valid}
        touched={this.state.mobileNumber.touched}
        shouldValidate={this.state.mobileNumber.validation !== null}
        placeholder={this.state.mobileNumber.elementConfig.placeholder}
        validationError={this.state.mobileNumber.validation ? this.state.mobileNumber.validation.validationError : null}
        changed={(event) => this.inputChangedHandler(event, 'mobileNumber')}
      />
    );

    let passwordUpdateFields = (
      <div>
        <Input
          className="MyAccount"
          value={this.state.oldPassword.value}
          elementType={this.state.oldPassword.elementType}
          elementConfig={this.state.oldPassword.elementConfig}
          invalid={!this.state.oldPassword.valid}
          touched={this.state.oldPassword.touched}
          shouldValidate={this.state.oldPassword.validation !== null}
          validationError={this.state.oldPassword.validation ? this.state.password.validation.validationError : null}
          placeholder="Current Password"
          changed={(event) => this.inputChangedHandler(event, 'oldPassword')}
        />
        <Input
          className="MyAccount"
          value={this.state.password.value}
          elementType={this.state.password.elementType}
          elementConfig={this.state.password.elementConfig}
          invalid={!this.state.password.valid}
          touched={this.state.password.touched}
          shouldValidate={this.state.password.validation !== null}
          validationError={this.state.password.validation ? this.state.password.validation.validationError : null}
          placeholder={this.state.password.elementConfig.placeholder}
          changed={(event) => this.inputChangedHandler(event, 'password')}
        />
        <Input
          className="MyAccount"
          value={this.state.passwordConfirmation.value}
          elementType={this.state.passwordConfirmation.elementType}
          elementConfig={this.state.passwordConfirmation.elementConfig}
          invalid={!this.state.passwordConfirmation.valid}
          touched={this.state.passwordConfirmation.touched}
          shouldValidate={this.state.passwordConfirmation.validation !== null}
          validationError={this.state.passwordConfirmation.validation ? this.state.passwordConfirmation.validation.validationError : null}
          placeholder={this.state.passwordConfirmation.elementConfig.placeholder}
          changed={(event) => this.inputChangedHandler(event, 'passwordConfirmation')}
        />
        <PasswordCriteriaHelper
          disabled={!this.state.password.touched && !this.state.passwordConfirmation.value}
          password={this.state.password.value}
          passwordConfirmation={this.state.passwordConfirmation.value}
          oldPassword={this.state.oldPassword.value}
          passwordConfirmationTouched={this.state.passwordConfirmation.touched}
        />
      </div>
    );

    if (this.props.loading === true) {
      passwordUpdateFields = <Spinner />;
      emailUpdateFields = <Spinner />;
    }

    const accountContainerClasses = [classes.MyAccountContainer];
    if (this.state.showProfileForm) accountContainerClasses.push(classes.ProfileFormVersion);
    let dialogue = null;
    if (this.state.showEmailEditDialogue) {
      dialogue = (
        <FormDialogue
          show
          title="Edit Email"
          cancelText="Cancel"
          confirmText="Save"
          className="MyAccount"
          cancel={this.toggleEmailDialogue}
          confirm={this.handleEmailUpdate}
          disabled={!this.state.email.valid}
          error={this.props.error}
        >
          {emailUpdateFields}
        </FormDialogue>
      );
    } else if (this.state.showPasswordEditDialogue) {
      dialogue = (
        <FormDialogue
          show
          title="Change Password"
          cancelText="Cancel"
          confirmText="Save"
          className="MyAccountPassword"
          cancel={this.togglePasswordDialogue}
          confirm={this.handlePasswordUpdate}
          disabled={!this.state.password.valid || !this.state.passwordConfirmation.valid}
          error={this.props.error}
        >
          {passwordUpdateFields}
        </FormDialogue>
      );
    } else if (this.state.showMobileEditDialogue) {
      dialogue = (
        <FormDialogue
          show
          title="Edit Phone"
          cancelText="Cancel"
          confirmText="Save"
          className="MyAccount"
          cancel={this.toggleMobileDialogue}
          confirm={this.submitMobileHandler}
          disabled={!this.state.mobileNumber.valid}
          error={this.props.error}
        >
          {mobileNumberUpdateField}
        </FormDialogue>
      );
    } else if (this.state.showVerifyMobileDialogue) {
      dialogue = (
        <Modal show className="VerifyMobile">
          <Verify isAccountManagement />
          <p className={classes.CancelMobileVerification}>Cancel</p>
        </Modal>
      );
    }
    const { FullName } = this.props.signedInAs || { FullName: '' };
    return (
      <div className={classes.ProfileContainer}>
        {dialogue}
        {this.props.signedInAs.FullName && !this.state.showProfileForm ? (
          <h2 className={classes.AccountOwnerName}>
            {FullName}'{FullName.slice(-1) === 's' ? '' : 's'} Account
          </h2>
        ) : null}
        <div className={accountContainerClasses.join(' ')}>{accountWindow}</div>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    signedInAs: state.user.signedInAs,
    error: state.user.error,
    submitted: state.user.submitted,
    loading: state.user.loading,
    emailUpdated: state.user.emailUpdated,
    passwordUpdated: state.user.passwordUpdated,
    managedUsers: state.user.managedUsers,
    accountVerified: state.auth.accountVerified,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onEmailUpdate: (email) => dispatch(actions.updateEmail(email)),
    onPasswordUpdate: (OldPassword, NewPassword) => dispatch(actions.updatePassword(OldPassword, NewPassword)),
    onInitProfileForm: (UserId, ThumbURL, FirstName, LastName, NickName, DateBirthDay, Color, ProfileStatus, isManagedUser, ShowModal) =>
      dispatch(
        actions.initProfileForm(UserId, ThumbURL, FirstName, LastName, NickName, DateBirthDay, Color, ProfileStatus, isManagedUser, ShowModal),
      ),
    onSubmitProfile: (UserId, profileImageId, FirstName, LastName, NickName, DateBirthDay, Color, Phone, profileCreated, isManagedUser) =>
      dispatch(
        submitProfile({
          UserId,
          profileImageId,
          FirstName,
          LastName,
          NickName,
          DateBirthDay,
          Color,
          Phone,
          profileCreated,
          isManagedUser,
        }),
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyAccount);
